// axios
import axios from 'axios'

// const baseURL = "https://floating-mountain-50737.herokuapp.com/api/v1.0"
const baseURL = "https://ferh-backend.herokuapp.com/api/v1.0"
//const baseURL = "http://127.0.0.1:8000/api/v1.0"

const api = axios.create({
  baseURL: baseURL,
  //withCredentials: false,
  // headers: {
  //   'Content-Type': 'application/json',
  //   'Cache-Control': 'no-cache',
  //   'Access-Control-Allow-Origin': '*',
  //   'Accept' : 'application/json, text/plain, */*',
  //   'Access-Control-Allow-Methods' : 'GET, PUT, POST, DELETE, OPTIONS',
  //   'Access-Control-Allow-Credentials' : false
  // }
})

export default api
